























































import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  setup() {
    const dialog = ref(false);

    return {
      dialog,
    };
  },
});

